import { AllSportsMenu } from './AllSportsMenu';

export * from './AllSportsMenu';

export default AllSportsMenu;
